import { render, staticRenderFns } from "./fail.vue?vue&type=template&id=c2e72daa&scoped=true"
import script from "./fail.vue?vue&type=script&lang=js"
export * from "./fail.vue?vue&type=script&lang=js"
import style0 from "./fail.vue?vue&type=style&index=0&id=c2e72daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e72daa",
  null
  
)

export default component.exports